import { createRouter, createWebHistory } from 'vue-router'

import activity from './activity'
import auth from './auth'
import blacklist from './blacklist'
import calendar from './calendar'
import globalCalendar from './globalCalendar'
import campaign from './campaign'
import campaignTags from './campaignTags'
import content from './content'
import dashboard from './dashboard'
import error from './error'
import feed from './feed'
import hashTags from './hashTags'
import imagelibrary from './imagelibrary'
import leaderboard from './leaderboard'
import log from './log'
import mynetwork from './myNetwork'
import pluginuninstall from './pluginuninstall'
import reporting from './reporting'
import signup from './signup'
// import smartlinks from './smartlinks'
import store from '@/store'
import tag from './tag'
import tagGroups from './tagGroups'
import task from './task'
import team from './team'
import test from './test'
import topic from './topic'

const routes = [
    ...auth,
    ...dashboard,
    ...feed,
    ...topic,
    ...tag,
    ...tagGroups,
    ...task,
    ...content,
    ...team,
    ...activity,
    ...mynetwork,
    ...log,
    ...campaign,
    ...blacklist,
    ...calendar,
    ...globalCalendar,
    ...signup,
    ...error,
    //    ...smartlinks,
    ...imagelibrary,
    ...test,
    ...reporting,
    ...campaignTags,
    ...hashTags,
    ...leaderboard,
    ...pluginuninstall,
    {
        path: '/reward',
        name: 'Reward',
        component: () => import('@/views/reward/RewardsView.vue'),
        meta: {
            layout: 'Default',
            abilities: [
                ['view', 'rewards'],
                ['manage', 'rewards'],
            ],
        },
    },
    {
        path: '/changelog',
        name: 'Changelog',
        component: () => import('@/views/changelog/GlobalChangelog.vue'),
        meta: {
            layout: 'Default',
            abilities: [['view', 'changelog']],
        },
    },
    {
        path: '/guest/share',
        name: 'ShareAsGuest',
        component: () => import('@/views/guest/ShareAsGuest.vue'),
        meta: {
            layout: 'Guest',
        },
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () => import('@/views/billing/Payment.vue'),
        meta: {
            layout: 'Default',
            abilities: [['manage', 'billing']],
        },
    },
    {
        path: '/unsubscribed',
        name: 'Unsubscribed',
        component: () => import('@/views/unsubscribed/Unsubscribed.vue'),
        meta: {
            layout: 'Default',
            abilities: [['*']],
        },
    },
    {
        path: '/:pathMatch(.*)',
        name: 'not-found',
        component: () => import('@/views/error/NotFound.vue'),
        meta: {
            layout: 'Error',
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach(async (to, from, next) => {

    if (
        !store.getters.isAuthenticated &&
        !store.getters.isAuthenticatedLimited
    ) {
        // Try refreshing token, but don't crash on failed request
        await store.dispatch('refreshToken').catch((e) => e)
    }

    const token = store.state.auth.token
    const tokenExpired = token ? store.getters.isTokenExpired : null

    if (store.getters.isAuthenticated) {
        if (to.name === 'Login') {
            next('/')
            return
        }
 
		if (to.meta?.abilities?.length > 0 &&
            to.name !== 'Workspace Finder' &&
            to.name !== 'Plugin Authenticated' &&
            to.name !== 'v1 redirect' &&
            to.name !== 'v2 redirect' &&
            to.name !== 'AutoVersion' &&
            to.name !== 'Root') {
			
			if (store.getters.selectedVersion == 1) {
				console.log('bounced - selected version is ' + store.getters.selectedVersion)
				next({ name: 'v1 redirect' })
				return
			}
	
			if (store.getters.workspaceDefaultVersion !== 2 && (store.getters.allowVersionSwitch === false || !store.getters.allRoles?.includes('admin'))) {
				console.log('bounced -- not allowed on v2')
				next({ name: 'v1 redirect' })
				return
			}
			
		}
		
		if (store.getters.isAuthenticated && store.getters.allowVersionSwitch && store.getters.selectedVersion === null) {
			await store.commit('selectVersion', 2)
		}

    }

    let allowed = true

    if (to.meta?.abilities?.length > 0) {
    
    	allowed = store.getters.isAuthenticated 
    
        // has abilities defined in the route (at least one)		
		if (store.getters.isAuthenticated) {
		
			if (typeof to.meta.abilities == 'function' || to.meta.abilities.indexOf('*') === -1) {

				const abilities = typeof to.meta.abilities == 'function' ? to.meta.abilities(to) : to.meta.abilities
				
				for (const ability of abilities) {
					let routeIdValue = null
					if (!allowed && to.meta.ownerIdParameter && ability[1].indexOf('my-') === 0) {
						routeIdValue = to.params[to.meta.ownerIdParameter]
					}
					allowed = await store.dispatch('can', {ability, ownerId: routeIdValue})
					if (allowed) {
						break
					} else if (store.getters.abilities?.length > 0) {
						console.log('Cannot access route due to missing permissions:')
				        console.log(store.getters.abilities)
				        console.log(to)
						console.log(to.meta)
					} else {
						next({ name: 'Workspace Finder' })
					}
				}
			}
		} else {
			console.log('Cannot access route, not authenticated:')
			console.log(to)		
		}
    }

    if (allowed) {
        next()
    } else {
    	if (store.getters.isAuthenticated) {
    		console.log(to)
    		console.log(from)
    		console.log('Not allowed but authenticated, redirecting to root.')
            next({name: 'Root'})
    	} else {
    		console.log('login')
    		next({name: 'Login', query: from.query ?? null})
    	}
    }

    store.commit('updateRouting', true)
})

router.afterEach(() => {
    store.commit('updateRouting', false)
})

export default router
